import { DefaultPreferences } from "./defaultPreference";
import {RoleData} from './roleData'


export class DefaultPreferenceResponse {
    defaultPreferences: DefaultPreferences[];
    roleData: RoleData[];
    constructor() {
        this.defaultPreferences = [];
        this.roleData = [];
    }
}










